import zappy from "@zappy-ride/library.react.components";
import { FormOutputVehicle } from "./FormOutputVehicle";

export * from "./FormOutputVehicle";

zappy.FactoryInstance.registerComponent(FormOutputVehicle);
